import studentsAPI from "../../../../services/students";
import { useAuthContext } from "../../../../hooks/useAuthContext";
import MeaButton from "../../../../components/MeaButton";
import { useRef, } from "react";
import UpdateRegistrationDetailsModal from "../modals/UpdateRegistrationDetailsModal";
import UpdateRegistrationFeedbackModal from "../modals/UpdateRegistrationFeedbackModal";
import { Toast } from "primereact/toast";
import UpdateRegistrationPreviousResultModal from "../modals/UpdateRegistrationPreviousResultModal";
import { Tag } from "primereact/tag";
import { Card } from "primereact/card";
import { PERMISSION_TRAINING_REGISTRATION, PERMISSION_TRAINING_TASKS } from "../../../../permissions";
import { ToFormatedDateForEvents } from "../../../../utils/dates";
import MeaMemberAvatar from "../../../../components/MeaMemberAvatar";
import RegistrationStepActions from "./RegistrationStepActions";

const RegistrationStepNewComponent = ({ currentStudent, setCurrentStudent, callback, schoolId, trainingId }) => {

    const { hasPermission, currentMembership } = useAuthContext();
    const accessToken = "";
    const toast = useRef(null);

    const hasUpdateRegistrationsStatusPermission = hasPermission(PERMISSION_TRAINING_TASKS.UPDATE_REGISTRATIONS_STATUS)

    const updateRegistrationPreviousResultModalRef = useRef(null);
    const updateRegistrationDetailsModalRef = useRef(null);
    const updateRegistrationFeedbackModalRef = useRef(null);

    const statusActionsRef = useRef(null);

    // Candidature details can only be edited after confirmation when the school allows it.
    const editLocked = currentStudent?.status === "ENROLLED" && !currentMembership?.school?.settings?.registration_allow_edit_after_confirmation;

    const updatePreviousTrainingInfos = async () => {
        studentsAPI.UpdatePreviousTrainingInfos(schoolId, trainingId, accessToken, currentStudent?.id)
            .then((data) => {

                toast.current.clear();
                toast.current.show({
                    severity: "success",
                    summary: "Succès",
                    detail: "Informations de la dernière inscription mis à jour!",
                    life: 3000,
                });
                callback?.();
            }
            )
            .catch((error) => {
                console.log("error", error);
            }
            );
    };

    const headerTemplate = (options) => {
        const className = `${options.className} justify-content-space-between`;
        return (
            <div className={className}>
                <div className="flex align-items-center gap-2">
                    <i className="text-2xl pi pi-id-card text-primary-500"></i>
                    <span className="font-bold">Candidature</span>
                </div>
                <div>
                    {currentStudent?.registration_new ? <Tag severity="warning" value="nouveau" className="ml-2" /> : ""}
                    {options.togglerElement}
                </div>
            </div>
        );
    };

    const footerTemplate = (options) => {
        const className = `${options.className} flex flex-wrap align-items-center justify-content-between`;

        return (
            <>
                {currentStudent?.status === "NEW" && (
                    <div className={className}>
                        <div className="flex align-items-center gap-2">
                            <MeaButton
                                tooltip="Mettre à jour les informations de candidature"
                                permission={PERMISSION_TRAINING_REGISTRATION.UPDATE}
                                icon="pi pi-refresh"
                                size="small"
                                text
                                onClick={updatePreviousTrainingInfos}
                                severity="secondary"
                                rounded
                            />
                        </div>

                        <div>
                            <RegistrationStepActions
                                ref={statusActionsRef}
                                currentStudent={currentStudent}
                                schoolId={schoolId}
                                trainingId={trainingId}
                                callback={callback}
                                primary={{
                                    label: "Pré-inscrire dans cette formation",
                                    icon: "pi pi-user-plus",
                                    disabled: !hasUpdateRegistrationsStatusPermission,
                                    onClick: () => statusActionsRef.current?.changeStatus("PREREGISTRED"),
                                }}
                                items={[
                                    {
                                        label: "Mettre en liste d'attente",
                                        icon: "pi pi-hourglass",
                                        visible: hasUpdateRegistrationsStatusPermission,
                                        command: () => statusActionsRef.current?.changeStatus("WAITING_LIST"),
                                    },
                                ]}
                            />
                        </div>
                    </div>
                )}
            </>
        );
    };

    return (
        <>
            <Toast ref={toast} position="bottom-center" />

            <Card footer={footerTemplate} >
                <ul className="list-none p-0 m-0 ">
                    <li className="flex align-items-center py-2 px-2 flex-wrap ">
                        <div className="text-500 w-full md:w-5 font-medium text-left md:text-right">Crée le</div>
                        <div className="text-900 w-full pl-3 md:w-7">
                            <div className="flex justify-content-between flex-wrap align-items-center">
                                <div className="w-full">{ToFormatedDateForEvents(new Date(currentStudent?.created_at), false) || "-"}</div>
                            </div>
                        </div>
                    </li>
                    <li className="flex align-items-center py-2 px-2 flex-wrap ">
                        <div className="text-500 w-full md:w-5 font-medium text-left md:text-right">Crée par</div>
                        <div className="text-900 w-full pl-3 md:w-7">
                            <div className="flex justify-content-between flex-wrap align-items-center">
                                <div className="w-full">{currentStudent?.created_by_member ? <MeaMemberAvatar member={currentStudent?.created_by_member} noNavigation={false} /> : "-"}</div>
                            </div>
                        </div>
                    </li>
                    <li className="flex align-items-center py-2 px-2 flex-wrap ">
                        <div className="text-500 w-full md:w-5 font-medium text-left md:text-right">Message des parents</div>
                        <div className="text-900 w-full pl-3 md:w-7">
                            <div className="flex justify-content-between flex-wrap align-items-center">
                                <div className="w-10">{currentStudent?.registration_details || "-"}</div>
                                <div className="w-2"><MeaButton permission={PERMISSION_TRAINING_REGISTRATION.UPDATE} disabled={editLocked} icon="pi pi-pencil" className="mr-2" size="small" text onClick={() => {
                                    if (updateRegistrationDetailsModalRef.current) {
                                        updateRegistrationDetailsModalRef.current.show(() => {
                                            callback?.();
                                        });
                                    }
                                }} /></div>
                            </div>
                        </div>
                    </li>
                    <li className="flex align-items-center py-2 px-2 flex-wrap ">
                        <div className="text-500 w-full md:w-5 font-medium text-left md:text-right">Message de l'école</div>
                        <div className="text-900 w-full pl-3 md:w-7">
                            <div className="flex justify-content-between flex-wrap align-items-center">
                                <div className="w-10">{currentStudent?.registration_feedback || "-"}</div>
                                <div className="w-2"><MeaButton permission={PERMISSION_TRAINING_REGISTRATION.UPDATE} disabled={editLocked} icon="pi pi-pencil" className="mr-2" size="small" text onClick={() => {
                                    if (updateRegistrationFeedbackModalRef.current) {
                                        updateRegistrationFeedbackModalRef.current.show(() => {
                                            callback?.();
                                        });
                                    }
                                }} /></div>
                            </div>
                        </div>
                    </li>
                </ul>
            </Card >
            <UpdateRegistrationPreviousResultModal ref={updateRegistrationPreviousResultModalRef} student={currentStudent} schoolId={schoolId} trainingId={trainingId} />
            <UpdateRegistrationDetailsModal ref={updateRegistrationDetailsModalRef} student={currentStudent} schoolId={schoolId} trainingId={trainingId} />
            <UpdateRegistrationFeedbackModal ref={updateRegistrationFeedbackModalRef} student={currentStudent} schoolId={schoolId} trainingId={trainingId} />
        </>
    );
}

export default RegistrationStepNewComponent;